import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { formatCurrency } from 'lib/formatting/currency'
import { ProbateEstateItem } from 'lib/models/probate-estate'
import {
  UTILITY_PROVIDER_SCHEMA,
  UTILITY_TYPE,
} from 'lib/probate/estate-questionnaire-schema'
import { getItemsTotals } from 'routes/probate-estate/fact-find/get-totals'

import RecordsSection, {
  RecordCollection,
  RecordsSubSectionProps,
} from '../../estate/records-section'
import { UTILITY_TYPE_OPTIONS } from '../../options'

const UtilityProviders = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => {
  // create only saves itemType and ownership, and an item with no
  // utilityType is an "Other bill" - so give it a type straight away to keep
  // it in this list. Awaiting the update keeps the add spinner going until
  // it's saved, and lets a failure of either request reach the add button's
  // catch in CollectionSection (the collection hook shows the error)
  const utilityCollection: RecordCollection = {
    ...collection,
    createItem: async (attributes) => {
      const created = (await collection.createItem(
        attributes
      )) as ProbateEstateItem
      await collection.updateItem(created.id, {
        utilityType: UTILITY_TYPE.OTHER,
      })
      return created
    },
  }

  // the same sum as the quote, so old fact-find debts with ownership
  // recorded add up the same way
  const { total } = getItemsTotals(collection.items as ProbateEstateItem[])
  const isNothingOwed = total === formatCurrency({ value: 0 })
  // debts reduce the estate, so show them as negative - unless nothing is owed
  const debtTotal = isNothingOwed ? total : `-${total}`

  return (
    <RecordsSection
      heading="3.1 Utility providers"
      cardType="Utility provider"
      addLabel="Add utility provider"
      toggleName="utilityProvidersSectionActive"
      sectionActive={sectionActive}
      saveProbateEstateField={saveProbateEstateField}
      collection={utilityCollection}
      schema={UTILITY_PROVIDER_SCHEMA}
      totals={{ total: debtTotal }}
      renderFields={({ handleSave }) => (
        <>
          <Grid.Item span={6}>
            <InputFloating
              name="utilityType"
              label="Utility type"
              component="select"
              options={UTILITY_TYPE_OPTIONS}
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={6}>
            <InputFloating
              name="providerName"
              label="Provider"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={6}>
            <InputFloating
              name="referenceNumber"
              label="Account number"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={6}>
            <InputFloating
              name="value"
              label="Value (£)"
              isCurrency
              handleSave={handleSave}
            />
          </Grid.Item>
        </>
      )}
    />
  )
}

export default UtilityProviders
